export const fnLink = () => {
    const ua = navigator.userAgent || navigator.vendor || window.opera;

    const isIPadOS =
        navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;

    const isAndroid = /Android/i.test(ua);
    const isIOS = /iPhone|iPad|iPod/i.test(ua) || isIPadOS;
    const isMac = /Macintosh|Mac OS X/i.test(ua) && !isIPadOS;
    const isWindows = /Windows/i.test(ua);

    if (isAndroid || isWindows) {
        window.location.href =
            "https://play.google.com/store/apps/details?id=kr.co.capl.parking";
        return;
    }

    if (isIOS || isMac) {
        window.location.href =
            "https://apps.apple.com/kr/app/capl/id6739181638";
        return;
    }

    window.location.href =
        "https://play.google.com/store/apps/details?id=kr.co.capl.parking";
};